import createReactComponent from '../createReactComponent';
export default createReactComponent('reception-bell', 'ReceptionBell', [["path",{"d":"M3 19h18M12 8V5m0 3h-2a5 5 0 0 0-5 5v3h14v-3a5 5 0 0 0-5-5zm0-3h-2m2 0h2","key":"svg-0"}]]);